import axiosPrivate from "./axiosPrivate"

export const uploadFacebookAdImage = async (accountId, formData, filename) => {
  const form = new FormData()
  form.append("bytes", formData)
  form.append("name",filename) 

  return await axiosPrivate.post(
    `https://graph.facebook.com/v21.0/act_${accountId}/adimages`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
}
